<template>
  <div class="ml-2 ml-md-5 ml-sm-2 mr-4 pb-3">
    <div class="row mt-3">
      <div class="col col-sm col-12 py-3">
        <em class="fas fa-file-invoice-dollar text-orange mr-1" />
        <span class="color-gray-7 font-16 font-weight-bold">
          Balance de Terapias Compensatorias
        </span>
      </div>
    </div>
    <div class="row py-4 mr-md-0">
      <div class="col-12 col-md-4">
        <div>
          <span class="color-gray-6 d-block font-14">
            Total de Servicios Adeudados:
          </span>
          <span class="font-16 color-black">
            {{ data.compensatoryTherapyBalance.totalServices | empty }}
          </span>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div>
          <span class="color-gray-6 d-block font-14">Servicios Ofrecidos:</span>
          <span class="font-16 color-black">
            {{ data.compensatoryTherapyBalance.servicesOffered | empty }}
          </span>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div>
          <span class="color-gray-6 d-block font-14">Balance Pendiente:</span>
          <span class="font-16 color-black">
            {{ data.compensatoryTherapyBalance.pendingBalance | empty }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContractBalanceOfTherapyCompensatory',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss"></style>
